import { useState } from "react";
import { CalculationsList } from "./CalculationsList";
import { CalculationEditor } from "./CalculationEditor";

/** Kalkulacije (v2): lista + uređivač. `editing`: null = lista, "new:TYPE" = nova, inače id. */
export function CalculationsTab() {
  const [editing, setEditing] = useState<string | null>(null);
  if (editing) {
    return <CalculationEditor key={editing} target={editing} onClose={() => setEditing(null)} onOpen={(id) => setEditing(id)} />;
  }
  return <CalculationsList onOpen={(id) => setEditing(id)} onNew={(type) => setEditing(`new:${type}`)} />;
}
